import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();

function fetchFieldConfigApi(payload:any) {
    const baseUrl = `${config.BACKEND_BASE_URL}/field-config/by-module-action`;
    return api.get(`${baseUrl}`,{})
}

export { fetchFieldConfigApi }